import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-inicio-denuncias',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './inicio-denuncias.component.html',
  styleUrls: ['./inicio-denuncias.component.css']
})
export class InicioDenunciasComponent {}
